import Vue from 'vue'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import VCharts from 'v-charts'
import Icon from 'vue-awesome/components/Icon'
import StompClient from './plugins/stomp-client'
import VueClipboard from 'vue-clipboard2'
import App from './App'
import router from './router'
import store from './store'
import VueAreaLinkage from 'vue-area-linkage'
import scrollReveal from 'scrollreveal'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import NoData from '@/components/client/common/NoData'
import 'swiper/dist/css/swiper.css'

import 'vue-area-linkage/dist/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/element-reset.scss'
import './assets/styles/default.scss'
// import './assets/styles/animation.scss'
// import './assets/styles/transition.scss'
import 'vue-awesome/icons'
// import UrlUtil from './utils/url-utils'
Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.use(VCharts)
Vue.use(VueAwesomeSwiper)
Vue.use(StompClient, {serverEndPoint: '/stomp/'})
Vue.use(VueAreaLinkage)
Vue.use(VueClipboard)
Vue.component('icon', Icon)
Vue.component('no-data', NoData)
Vue.config.silent = true

Vue.directive('focus', {
  // 当绑定元素插入到 DOM 中。

  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})
/* // 登录模式路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (JSON.parse(sessionStorage.getItem('user'))) {
      next()
    } else {
      next({
        path: '/work-bench',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
}) */
/* url地址解析 */
// let url = window.location.href
// let compose = UrlUtil.parse(url)
/* eslint-disable no-new */
// if (compose.file === 'index.html' || compose.file === '') {
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {App}
})
// }
Vue.prototype.scrollReveal = scrollReveal()
Vue.prototype.ani = function () {
  this.scrollReveal.reveal('.showUp', {
    duration: 1500,
    origin: 'top',
    reset: true,
    distance: '300px'
  })
  this.scrollReveal.reveal('.showRight', {
    duration: 1500,
    origin: 'right',
    reset: true,
    distance: '300px'
  })
  this.scrollReveal.reveal('.showDown', {
    duration: 1500,
    origin: 'bottom',
    reset: true,
    distance: '300px'
  })
  this.scrollReveal.reveal('.showLeft', {
    duration: 1500,
    origin: 'left',
    reset: true,
    distance: '300px'
  })
}
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js